import React from "react";
import { useHistory } from "react-router-dom";

const ChangePassword = ({ data }) => {
  const history = useHistory();
  return (
    <div className="ss_container">
      <div className="ss_md">
        <div className="ss_sd">
          <h6>SECURITY SETTINGS</h6>
          <h5>CHANGE PASSWORD</h5>
          <div className="ss_inp">
            <input type="text" placeholder="Old Password" />
            <input type="text" placeholder="New Password" />
            <input type="text" placeholder="Confirm New Password" />
          </div>
          <div className="ss_btn">
            <button className="cus_blue_btn">Change Paasword</button>
          </div>
          <div className="dlt_acc_md">
            <h6>DELETE ACCOUNT</h6>
            <p>{data?.auth?.delete_account}</p>
          </div>
          <div className="ss_btn">
            <button
              onClick={() => history.push("/delete-account")}
              className="cus_blue_btn dlt_red"
            >
              Delete Account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
